import {
    Box,
    chakra
} from '@chakra-ui/react';

export const container = chakra(Box, {
    label: 'app-init-container',
    baseStyle: { overflow: 'hidden' },
    height: '100dvh'
});
